"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _config = require("../state/entities/config");
var _rcPreferences = require("../state/entities/rcPreferences");
var _locale = require("../utils/locale");
var localConfig = _interopRequireWildcard(require("../config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useConfig = () => {
  const config = (0, _reactRedux.useSelector)(_config.configSelectors.values) || localConfig;
  const preferredLocale = (0, _reactRedux.useSelector)(_rcPreferences.rcPreferencesSelectors.locale);
  const locale = (0, _locale.getIsLocaleSupported)(preferredLocale) ? preferredLocale : config.locale;
  return {
    ...config,
    locale
  };
};
var _default = exports.default = useConfig;